import {
	PcQuoteDetails,
	PcRestartResponse,
	UpdatePrivateCarQuoteCommand,
} from '@acorn-portal/shared/src/services/subscriptionAPI';
import { PcDriver } from '@acorn-portal/shared/src/services/subscriptionAPI';
/**
 * Prepares an update command for a private car quote with amended driver data.
 *
 * @param quoteReference - The reference ID for the quote.
 * @param quoteToken - The token for the quote.
 * @param workingDriverData - The list of driver data to update.
 * @param workingQuoteData - The current quote data.
 * @returns The command object to update the private car quote.
 * @throws If no drivers are found on the quote data.
 */
export function prepareQuoteCommand(
	quoteReference: string,
	quoteToken: string,
	workingDriverData: PcDriver[],
	workingQuoteData: PcRestartResponse | undefined,
): UpdatePrivateCarQuoteCommand {
	if (!workingQuoteData?.quoteDetails?.riskData?.driverDetails) throw new Error('No drivers found on quote data');

	// Update the driver details in the quote data with the working driver data
	workingQuoteData.quoteDetails.riskData.driverDetails = workingDriverData;

	return {
		quoteReference,
		quoteToken,
		quoteDetails: workingQuoteData?.quoteDetails as PcQuoteDetails,
	};
}
